import { useConsolidateResolution886Report } from '@/hooks/v2/resolution-886/useConsolidateResolution886Report';
import type { Resolution886ReportResponse } from '@/context/Resolution886Report/types';
import type { PDFSectionsResolution886 } from '@/components/views/Resolution886/enums';

interface ConsolidateValues {
	status: boolean;
	include_fields?: PDFSectionsResolution886[];
}

export const useConsolidate = (report: Resolution886ReportResponse, companyId: string, organizationId: string) => {
	const { mutateAsync: consolidateReport, isLoading: consolidateReportLoading } = useConsolidateResolution886Report();

	const reviewId = report?.reviews?.[0]?.id;
	const isReportConsolidated = report?.reviews?.[0]?.consolidated;

	async function handleConsolidate(values: ConsolidateValues): Promise<void> {
		if (!report?.id || !companyId || !organizationId || !reviewId) {
			return;
		}

		const parameters = {
			organization_id: organizationId,
			company_id: companyId,
			report_id: report.id,
			review_id: reviewId,
			consolidated: values.status,
			locale: window.navigator.language,
			include_fields: values.include_fields || []
		};

		await consolidateReport(parameters);
	}

	return {
		handleConsolidate,
		consolidateReportLoading,
		isReportConsolidated
	};
};
